import React from 'react';
import Modal from 'react-modal';
import { getCookie } from '../../inc/cookies';
import swal from 'sweetalert';
import config from '../../inc/config';

export default class VehicleDamagePhotoNameModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isCompleted: true,

      damageName: this.props.damageName || '',
			DamageTypes: [
				{type: 'Ön Tampon'},
				{type: 'Ön Kaput'},
				{type: 'Tavan'},
				{type: 'Sağ Ön Çamurluk'},
				{type: 'Sağ Ön Kapı'},
				{type: 'Sağ Arka Kapı'},
				{type: 'Sağ Arka Çamurluk'},
				{type: 'Sol Ön Çamurluk'},
				{type: 'Sol Ön Kapı'},
				{type: 'Sol Arka Kapı'},
				{type: 'Sol Arka Çamurluk'},
				{type: 'Arka Kaput'},
				{type: 'Arka Tampon'}
			]
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

	componentDidUpdate(prevProps) {
    if (prevProps.damageName !== this.props.damageName) {
      this.setState({
        damageName: this.props.damageName || ''
      });
    }
  }

  updatePhotoName() {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'PUT',
      headers: {'Authorization': 'Bearer ' + sessionHash, 'Content-Type': 'application/json'},
      body: JSON.stringify({name: this.state.damageName})
    };

    fetch(config.restApi + 'auctionVehicleDamagePhotoName/tr/' + this.props.photoId, requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch (responseData.status) {
        case 200: {
          swal({
            dangerMode: true,
            icon: 'success',
            title: 'Tamamlandı',
            text: 'Fotoğraf ismi başarıyla güncellendi.',
            buttons: 'Tamam'
          }).then(() => this.setState({isLoading: true}, () => {this.props.onRotationDamagePhotoCompleted(); this.setState({isLoading: false}); this.props.onRequestClose();}));
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }
 
  render() {
    return (
      <div className="modal inmodal">
        <div className="modal-dialog">
          <div className="modal-content animated fadeIn">
          <Modal
            isOpen={this.props.isOpen}
            onRequestClose={this.props.onRequestClose}
            style={{
              content : {
                position : 'null',
                top : 'null',
                left : 'null',
                right : 'null',
                bottom : 'null',
                border : 'none',
                background : '#fff',
                padding : 'null',
                maxWidth : '50%',
                minWidth : '350px'
              },
              overlay : {
                position : 'fixed',
                top : 0,
                left : 0,
                right : 0,
                bottom : 0,
                display : 'flex',
                alignItems : 'center',
                justifyContent : 'center',
                backgroundColor : 'rgba(0,0,0,00.1)',
                zIndex:2500
              }
            }}
          >
            <div className={this.state.isCompleted ? "ibox-content no-padding" : "ibox-content sk-loading no-padding"}>
              <div className="sk-spinner sk-spinner-fading-circle">
                <div className="sk-circle1 sk-circle"></div>
                <div className="sk-circle2 sk-circle"></div>
                <div className="sk-circle3 sk-circle"></div>
                <div className="sk-circle4 sk-circle"></div>
                <div className="sk-circle5 sk-circle"></div>
                <div className="sk-circle6 sk-circle"></div>
                <div className="sk-circle7 sk-circle"></div>
                <div className="sk-circle8 sk-circle"></div>
                <div className="sk-circle9 sk-circle"></div>
                <div className="sk-circle10 sk-circle"></div>
                <div className="sk-circle11 sk-circle"></div>
                <div className="sk-circle12 sk-circle"></div>
              </div>
              <div className="modal-header d-block text-center text-darkblue">
                <button className="close" onClick={() => this.props.onRequestClose()}><span>×</span></button>
                <h4 className="modal-title">{this.props.modalTitle}</h4>
                <h5 className="font-normal">{this.props.modalDescription}</h5>
              </div>
              <div className="modal-body text-darkblue d-flex justify-content-center p-1">
                <img style={{width:345, height: 345, objectFit:"contain", overflow: "visible"}} src={`https://file.satisgaranti.com/${this.props.photoPath}`}/>
              </div>
              <div className="col-12 p-2">
								<h5><strong>Hasar Bölgesi<strong className="text-danger ml-1">*</strong></strong></h5>
								<select className="form-control b-r-sm m-b mr-2" name="Hasar Bölgesi" onChange={event => this.setState({damageName: event.target.value})} value={this.state.damageName}>
									<option value="" disabled>Hasar Bölgesi</option>
									{this.state.DamageTypes.map((damageType, index) =>
										<option key={index} value={damageType.type}>{damageType.type}</option>
									)}
								</select>
							</div>
              <div className="modal-footer"> 
                <button className="btn btn-orange" onClick={() => this.updatePhotoName()}>Kaydet</button>
              </div>
            </div>
          </Modal>
          </div>
        </div>
      </div>
    )
  }
}
